module.exports = __webpack_public_path__ + "img/北京地址切图.dbe0452c.jpg";